export function computeAuthorizationState(intent) {
  if (intent.authorized || intent.on_chain_authorized) return 'APPROVED';
  if (intent.authorization_state && intent.authorization_state !== 'PENDING') return intent.authorization_state;
  return 'PENDING';
}

export function computeExecutionState(intent) {
  if (intent.execution_proof) {
    return intent.execution_proof.success ? 'SUCCEEDED' : 'FAILED';
  }
  if (intent.execution_outcome === 'SUCCEEDED') return 'SUCCEEDED';
  if (intent.execution_outcome === 'FAILED') return 'FAILED';
  if (intent.execution_state === 'RUNNING') return 'RUNNING';
  if (intent.execution_state && intent.execution_state !== 'NOT_EXECUTED') return intent.execution_state;
  return 'NOT_EXECUTED';
}

export function deriveDisplayState(intent) {
  const authorizationState = computeAuthorizationState(intent);
  const executionState = computeExecutionState(intent);

  if (authorizationState !== 'APPROVED') {
    return 'AWAITING_APPROVAL';
  }
  if (executionState === 'SUCCEEDED' || executionState === 'FAILED') {
    return 'EXECUTED';
  }
  return 'APPROVED_NOT_EXECUTED';
}

export function formatStatusLabel(intent) {
  const authorizationState = computeAuthorizationState(intent);
  const executionState = computeExecutionState(intent);

  if (authorizationState !== 'APPROVED') {
    return 'Awaiting approval';
  }
  if (executionState === 'RUNNING') {
    return 'Approved · Awaiting deployment';
  }
  if (executionState === 'NOT_EXECUTED') {
    return 'Approved · Awaiting deployment';
  }
  if (executionState === 'SUCCEEDED') {
    return 'Deployment executed · Succeeded';
  }
  if (executionState === 'FAILED') {
    return 'Deployment executed · Failed';
  }
  return 'Approved · Awaiting deployment';
}
